import { html } from "lit";
var icon_actions_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g fill-rule="evenodd" transform="translate(13.5 4)">
      <circle cx="2.571" cy="2.571" r="2.571" />
      <circle cx="2.571" cy="12" r="2.571" />
      <circle cx="2.571" cy="21.429" r="2.571" />
    </g>
  </svg>
`;
export {
  icon_actions_default as default
};
//# sourceMappingURL=icon-actions.js.map
